export default __webpack_public_path__ + "static/media/youtube-icon.74b6c851.svg";